<template>
  <div id="forMoreLink" class="page-content">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>数据中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/BrandMerchandise' }">品牌商品库</el-breadcrumb-item>
      <!-- <el-breadcrumb-item>待获取详情链接</el-breadcrumb-item> -->
      <el-breadcrumb-item>快速入库详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="yellowStyle">
      <img src="../../../assets/img/other/trumpet_icon.png" style="margin-right: 5px;">
      <span>
        数据获取异常的链接，可以点击重试后，重新获取。已获取的链接仅保留最近7日内的数据，超过七日将自动被删除。
      </span>
    </div>
    <div class="bigClass">
      <el-row>
        <div style="position: absolute;right: 0;z-index: 999;">
          入库时间
          <el-date-picker
            size="small"
            v-model="searchformDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="margin: 0px 0px 15px 10px;"
            @change="oneStep">
          </el-date-picker>
        </div>
        <el-col :span="24">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label='"待获取" + " (" + first + ")"' name="first"></el-tab-pane>
            <el-tab-pane :label='"获取中" + " (" + fifth + ")"' name="fifth"></el-tab-pane>
            <el-tab-pane :label='"数据获取异常" + " (" + third + ")"' name="second"></el-tab-pane>
            <el-tab-pane :label='"链接下架或失效" + " (" + second + ")"' name="third"></el-tab-pane>
            <el-tab-pane :label='"已获取" + " (" + fourth + ")"' name="fourth"></el-tab-pane>
          </el-tabs>
        </el-col>
        <el-col :span="24">
          <el-button @click="onOpenDeleteDia(2)" size="small" style="margin-right: 8px;" type="primary">批量删除</el-button>
          <el-button @click="retryFastStockInError(1)" size="small" style="margin-right: 8px;" v-if="activeName == 'second'">批量重试</el-button>
          <el-button @click="downTable" size="small" :loading="downTableTrue">下载数据</el-button>
          <el-button @click="BulkImportShow = true" size="small" style="margin-left: 8px;" v-if="activeName == 'first' && platform == 'PDD'">批量导入</el-button>
          <el-button @click="importTemplateMb" size="small" style="margin-left: 8px;" v-if="activeName == 'first' && platform == 'PDD'">下载模板</el-button>
        </el-col>
      </el-row>
      <div class="prompt">
        <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
        共<span class="promptFont">{{totalNum}}</span>项,已选择<span class="promptFont">{{openNumber}}</span>项
        <span class="promptFont2" @click="toggleSelection([tableData])">勾选全部</span>
        <span class="promptFont">/</span>
        <span class="promptFont2" @click="toggleSelection()">取消勾选</span>
      </div>
      <el-table
        @selection-change="handleSelectionChange"
        :data="tableData"
        style="width: 100%;margin-top: 5px;"
        ref="multipleTable"
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        >
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column label="序号" width="120">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column label="链接地址">
          <template slot-scope="scope">
            <el-link :underline="false" :href="scope.row.itemlink" target="_blank" type="primary">
              {{scope.row.itemlink}}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="realname" label="状态">
          <template slot-scope="scope">
            <div v-if="scope.row.infoStatus == '0'">
              <i class="el-icon-time" style="color: blue;padding-right: 8px;"></i>待获取
            </div>
            <div v-if="scope.row.infoStatus == '1'">
              <i class="el-icon-warning" style="color: blue;padding-right: 8px;"></i>获取中
            </div>
            <div v-if="scope.row.infoStatus == '3'">
              <i class="el-icon-circle-close" style="color: red;padding-right: 8px;"></i>数据获取异常
            </div>
            <div v-if="scope.row.infoStatus == '2'">
              <i class="el-icon-circle-close" style="color: red;padding-right: 8px;"></i>链接下架或失效
            </div>
            <div v-if="scope.row.infoStatus == '4'">
              <i class="el-icon-circle-check" style="color: green;padding-right: 8px;"></i>已获取
            </div>

          </template>
        </el-table-column>
        <el-table-column label="入库时间">
          <template slot-scope="scope">
            {{ scope.row.createtime.substring(0,19) }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="onOpenDeleteDia(1,scope.row.id)">删除</el-button>
            <el-button type="text" size="small" @click="retryFastStockInError(scope.row.id)" v-if="scope.row.infoStatus == '3'" style="margin-left: 8px;">重试</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-show="this.tableData.length > 0">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 30, 40]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
    </div>
    <!-- 删除 -->
    <el-dialog
      title="提示"
      :visible.sync="deleteShow"
      width="360px" style="margin-top: 10%;" id="dialog">
        <div style="display: flex;width: 100%;justify-content:center;">
          <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
          <div>
            <div style="font-size: 16px;">
              你确认要删除<span>{{delType}}</span>入库信息吗？
            </div>
            <div style="font-size: 14px;">删除后
              <span style="color: #e90e24;font-size: 14px;">
                入库信息将会被彻底删除
              </span>
            </div>
          </div>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deletefastStockIn" size="small" :loading="ficationLoading">确 定</el-button>
        <el-button @click="delCancel" size="small" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 批量导入 -->
    <el-dialog title="批量导入"
        class="importModal"
        :visible.sync="BulkImportShow"
        :close-on-click-modal="false"
        width="640px"
        id="dialog">
        <div class="wrap" style="margin: 10px;">
          <el-upload
            ref="newupload"
            class="upload-demo"
            drag
            action="hcm/iprNewPluginList/readExcelFile"
            :auto-upload="false"
            multiple
            :before-upload="beforeUpload"
            accept=".xls,.xlsx"
            :on-success="confirmUpload"
          >
          <i class="el-icon-upload" style="color: #BDA571;"></i>
          <div class="el-upload__text" style="font-size: 16px;color: #333333;">将文件拖到此处，或<em>点击上传</em>
            <br>
            <span style="font-size: 14px;color: #d4d4d4;">
              支持扩展名：.xls .xlsx
            </span>
          </div>
          </el-upload>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="BulkImport()" size="small" :loading="bulLoading">确 定</el-button>
          <el-button @click="BulkImportShowf()" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
  import pagination from "../../../components/dataTable/pagination";
  export default {
    data() {
      return {
        tableLoading:false,
        activeName: 'first',
        openNumber: 0,
        downTableTrue: false,
        tableData: [],
        pageNo: 1,
        pageSize: 10,
        currentPage: 1,
        totalNum: 10,
        infoStatus:'0',
        searchformDate:[],
        platform:'',
        deleteShow: false,
        delType: '',
        ficationLoading: false,
        first: '',
        second: '',
        third: '',
        fourth: '',
        fifth: '',
        checkAll: '',
        BulkImportShow: false,
        bulLoading: false,
      }
    },
    mounted() {
      this.platform = this.$route.query.platform
      console.log(this.platform)
      this.oneStep()
    },
    methods: {
      // 确定导入
      BulkImport() {
        this.bulLoading = true
        this.$refs.newupload.submit();
      },
      // 取消导入
      BulkImportShowf() {
        this.BulkImportShow = false
        this.$refs.newupload.clearFiles();
      },
      beforeUpload(file) {
        let Xls = file.name
        if(Xls.search("xls") != -1 || Xls.search("xlsx") != -1){
          return file
        }else {
          this.$message.error('上传文件只能是 xls/xlsx 格式!')
          this.bulLoading = false
          return false
        }
      },
      confirmUpload(response) {
        console.log(response.message) 
        this.bulLoading = false
        this.$message({
          message: '成功',
          type: 'success'
        });
        this.BulkImportShow = false
        this.oneStep();
      },
      importTemplateMb() {
        fetch({
          url: "hcm/iprNewPluginList/exportExcel",
          method: "post",
          noFormat: true,
          responseType: "blob",
          timeout: 60 * 1000 * 5
        }).then(res => {
          //下载
          let url = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "批量导入模板.xlsx");
          document.body.appendChild(link);
          link.click();
        });
      },
      fastStockInNum() {
        let params={
          platform: this.platform
        }
        if (this.searchformDate && this.searchformDate.length > 1) {
          params.startTime = this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0,10);
          params.endTime = this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0,10);
        }
        fetch({
          url: "hcm/iprNewPluginList/fastStockInNum",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            for (let a in res.data) {
              if (res.data[a].info_status == 0) {
                this.first = res.data[a].count
              }
              if (res.data[a].info_status == 1) {
                this.fifth = res.data[a].count
              }
              if (res.data[a].info_status == 2) {
                this.second = res.data[a].count
              }
              if (res.data[a].info_status == 3) {
                this.third = res.data[a].count
              }
              if (res.data[a].info_status == 4) {
                this.fourth = res.data[a].count
              }
            }
          }
          this.tableLoading = false
        })
      },
      handleClick(tab, event) {
        if (tab.index == 0) {
          this.infoStatus = 0
        } else if (tab.index == 1) {
          this.infoStatus = 1
        } else if (tab.index == 2) {
          this.infoStatus = 3
        } else if (tab.index == 3) {
          this.infoStatus = 2
        } else {
          this.infoStatus = 4
        }
        this.pageNo = 1
        this.pageSize = 10
        this.openNumber = 0
        this.oneStep()
      },
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.oneStep();
      },
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.oneStep();
      },
      downTable(row) {
        let that = this;
        that.downTableTrue = true
        let datas = {}
        if (this.infoStatus || this.infoStatus == 0) {
          datas.infoStatus = this.infoStatus;
        }
        if (this.searchformDate.length > 1) {
          datas.startTime = this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0,10);
          datas.endTime = this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0,10);
        }
        fetch({
          url: "hcm/iprNewPluginList/exportFastStockInData",
          method: "get",
          params: datas,
          noFormat: true,
          responseType: "blob",
          timeout: 60 * 1000 * 5
        }).then(res => {
          //下载
          let url = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "详情链接.xlsx");
          document.body.appendChild(link);
          link.click();
          that.downTableTrue = false
        });
      },
      oneStep() {
        this.tableLoading = true
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          platform: this.platform
        }
        if (this.infoStatus || this.infoStatus == 0) {
          params.infoStatus = this.infoStatus;
        }
        if (this.searchformDate && this.searchformDate.length > 1) {
          params.startTime = this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0,10);
          params.endTime = this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0,10);
        }
        fetch({
          url: "hcm/iprNewPluginList/fastStockInData",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.fastStockInNum()
            this.tableData = data.content
            this.totalNum = data.totalElements
          }
        })
      },
      // 序号勾选
      handleSelectionChange(val) {
        if (this.checkAll != 2) {
          this.openNumber = val.length;
          this.selectRows = val;
        }
      },
      // 勾选
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleAllSelection(row);
            this.openNumber = this.totalNum
            this.checkAll = 2
          });
        } else {
          this.$refs.multipleTable.clearSelection();
          this.checkAll = 1
          this.openNumber = 0
        }
      },
      // 确认删除
      deletefastStockIn() {
        this.ficationLoading = true
        let params = {
          ids: this.delIds,
          infoStatus: this.infoStatus
        }
        fetch({
          url: "hcm/iprNewPluginList/deletefastStockIn",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.ficationLoading = false
            this.deleteShow = false
            this.$message({
              message: '成功',
              type: 'success'
            });
            this.openNumber = 0
            this.oneStep();
          } else {
            this.$message.error(res.message);
          }
        })
      },
      // 取消删除
      delCancel() {
        this.deleteShow = false
        this.delType = ''
        this.checkAll = ''
        this.delIds = ''
      },
      // 删除
      onOpenDeleteDia(e,ids) {
        this.delIds = ''
        if (ids && e == 1) {
          this.delType = '该'
          this.delIds = ids
        } else if (this.checkAll == 2 && e == 2) {
          this.delType = '全部'
          this.delIds = "checkAll"
        } else {
          this.delType = this.openNumber + '条'
          let arrIds = []
          for (let i in this.selectRows) {
            arrIds.push(this.selectRows[i].id)
          }
          this.delIds = arrIds.join(',')
        }
        if (this.delIds == '' || this.openNumber == 0) {
          this.$message({
            message: '没有选中项',
            type: 'warning'
          });
          return
        }
        this.deleteShow = true
      },
      retryFastStockInError(id) {
        let params = {
          platform: this.platform,
          infoStatus: this.infoStatus
        }
        if (this.searchformDate && this.searchformDate.length > 1) {
          params.startTime = this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0,10);
          params.endTime = this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0,10);
        }
        if (id != 1) {
          params.ids = id
        } else {
          if (this.checkAll == 2) {
            this.delType = '全部'
            this.delIds = "checkAll"
          } else {
            let arrIds = []
            for (let i in this.selectRows) {
              arrIds.push(this.selectRows[i].id)
            }
            this.delIds = arrIds.join(',')
          }
          params.ids = this.delIds
        }
        fetch({
          url: "hcm/iprNewPluginList/retryFastStockInError",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$message({
              message: '成功',
              type: 'success'
            });
            this.oneStep();
          } else {
            this.$message.error(res.message);
          }
        })
      },

    },
    components: {
      pagination
    }
  }
</script>
<style scoped lang="scss">
  .page {
    margin: 20px;
    background-color: white;
  }
</style>
<style lang="scss">
#forMoreLink {
  .yellowStyle {
    padding: 8px;
    background-color: #fdf6ec;
    border-color: #faecd8;
    color: #e6a23c;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    margin-bottom: 16px;
  }
  .bigClass {
    border-radius: 10px;
    padding: 16px;
    background-color: white;
    margin-bottom: 16px;
  }
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-table__empty-text{
    padding-top: 100px;
    background: url("../../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }
  .el-dialog__header {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #d9d9d9;
  }
  .el-table thead {
    color: #333333;
    font-weight: 500;
  }
  .el-button+.el-button {
    margin-left: 0px;
  }
  .bottom_page .el-pagination {
    text-align: right;
    margin-top: 0px;
    padding-bottom: 0px;
  }
  .prompt {
    height: 28px;
    border: 1px solid #108cee;
    background-color: #e6f7ff;
    border-radius: 5px;
    line-height: 28px;
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .promptFont{
    color: #108cee;
    font-size: 14px;
    margin-left: 3px;
    margin-right: 3px;
  }
  .promptFont2{
    color: #108cee;
    font-size: 14px;
    margin-left: 3px;
    margin-right: 3px;
    cursor: pointer;
  }
}
</style>
